import {isFilled} from '@prismicio/helpers';
import type {PrismicDocument} from '@prismicio/types';
import {OpenGraphMetaTag, useCanonicalURL, useHead, useOpenGraphMetaTags, useRequestURL, useSeoMeta, useTranslation} from '#imports';

export function useDocumentMetadata(document: PrismicDocument) {
    const {t} = useTranslation();
    const openGraphMeta = new OpenGraphMetaTag({
        title: document.data.openGraphTitle ?? document.data.metaTitle ?? undefined,
        description: document.data.openGraphDescription ?? document.data.metaDescription ?? undefined,
        image: isFilled.image(document.data.openGraphImage) ? document.data.openGraphImage.url : undefined,
        t,
    });
    useSeoMeta({
        title: document.data.metaTitle ?? openGraphMeta.title,
        description: document.data.metaDescription ?? openGraphMeta.description,
    });
    useOpenGraphMetaTags(openGraphMeta);

    const {href} = useRequestURL();
    const {defineCanonical} = useCanonicalURL();
    defineCanonical(href);

    if (document.data?.noIndex) {
        useHead({
            meta: [
                {
                    name: 'robots',
                    content: 'noindex',
                },
            ],
        });
    }
}
